<script>
   /*************************************************************/
   /* Widget for trimming tails                                 */
   /* -----------------------------------                       */
   /*************************************************************/

   import { Container, Range } from 'svelte-controls-basic';
   import PrepTemplate from './PrepTemplate.svelte';

   let {
      params = $bindable(),
      varind = $bindable(),
      settings = $bindable(),
      isOpen,
      left,
      right,
      nvars,
      ...others
   } = $props();

   // prefix for the label ids the controls below are named by, unique per widget instance
   const uid = $props.id();


   // initial settings
   const title = 'Trim tails';
   let show = $state(false);
   // the least width a trim keeps, held to the interval: behind a trim that leaves less than that,
   // which the clip of an edit can, the right handle's floor would sit above its ceiling, and the
   // range control's correction and the effect below then write the value back and forth
   const delta = $derived.by(() => {
      const d = nvars ? Math.round(nvars * 0.10) : 1;
      return right - left < d ? right - left : d;
   });


   // effect to make sure that params values are correct: each bound inside the interval, and the
   // right one at least "delta" above the left, which the handles below keep afterwards
   $effect(() => {
      if (isOpen) {
         if (params[0] === undefined || params[0] === null || params[0] < left ||
             params[0] > right - delta) params[0] = left;
         if (params[1] === undefined || params[1] === null || params[1] > right ||
             params[1] < params[0] + delta) params[1] = right;
         varind[1] = params[0];
         varind[2] = params[1];
         show = true;
      } else {
         varind[1] = -1;
         varind[2] = -1;
         show = false;
      }
   });


   $effect(() => {
      settings = 'left: ' + params[0] + ' right: ' + params[1];
   });

</script>

<PrepTemplate {title} {settings} {isOpen} {...others}>
   {#if show}
   <!-- each handle is bounded by the other: bounded by the interval alone they could cross -->
   <Container label="Left" id="{uid}-left">
   <Range bind:value={params[0]} min={left} max={params[1] - delta} step={1} decNum={0} />
   </Container>
   <Container label="Right" id="{uid}-right">
   <Range bind:value={params[1]} min={params[0] + delta} max={right} step={1} decNum={0} />
   </Container>
   {/if}
</PrepTemplate>
